import { render } from "./BsToast.vue?vue&type=template&id=5c9d1a19&scoped=true&ts=true"
import script from "./BsToast.vue?vue&type=script&lang=ts"
export * from "./BsToast.vue?vue&type=script&lang=ts"

import "./BsToast.vue?vue&type=style&index=0&id=5c9d1a19&lang=scss&scoped=true"

import exportComponent from "/home/vsts/work/1/s/node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5c9d1a19"]])

export default __exports__